import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';


import Avatar from '../../Avatar';
import Views from '../../Views';
import Answers from '../../Answers';
import DateSince from '../../Date';
import Icon from "../../Icon";
import createLink from "../../../../libs/createLink";
import DraftContentExcerpt from "../../editor/DraftContentExcerpt";
import {isNoFollowProfil} from "../../../../libs/helper";

class TopicStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
            isHidden: false,
        };
    }

    render() {
        let content = this.props.parentId ? this.props.parentId.contentRaw :  "";
        let link = createLink("forumTopic", {category : {slug : this.props.parentId.forum.slug, _id : this.props.parentId.forum._id}, topic : {_id : this.props.parentId._id, slug : this.props.parentId.slug}});

        let hasOwner = this.props.parentId.owner !== null && this.props.parentId.owner._id && this.props.parentId.owner;
        let hasLastCommentOwner = this.props.parentId.lastComment.owner !== null && this.props.parentId.lastComment.owner._id && this.props.parentId.lastComment.owner;
        let relLinkProfil = isNoFollowProfil(this.props.parentId.owner) ? { rel: "nofollow" } : {};
        let relLinkProfilLastComment = isNoFollowProfil(this.props.parentId.lastComment.owner) ? { rel: "nofollow" } : {};
        return (
            <div
                className={"card article-status forum-status-card"}>
                <Fragment>
                    <div className="wrapper">
                        <div className="wrap column">
                            <div className="username row">
                                {hasOwner ? (
                                    <Link to={createLink("userProfile", this.props.parentId.owner)} {...relLinkProfil}>
                                        <Avatar avatar={this.props.parentId.owner && this.props.parentId.owner.profile.avatar}
                                                gender={this.props.parentId.owner ? this.props.parentId.owner.profile.gender : "guest"}
                                                alt=""/>
                                    </Link>
                                ) : (
                                    <Avatar gender={"guest"} />
                                )}
                                <div className="column full">
                                    <div className="row wrap full pl-0 user-detail-article">
                                        {hasOwner ? (
                                            <Link to={createLink("userProfile", this.props.parentId.owner)} {...relLinkProfil}>
                                                {this.props.parentId.owner.username}
                                            </Link>
                                        ) : (
                                            <span>{this.props.parentId.authorName}</span>
                                        )}&nbsp;
                                        {/*{this.props.type === "blog" ? `a publié dans son blog` : this.props.type === "forum" && "a publié un sujet dans le forum"}{this.props.type === "blog" && (*/}
                                        {/*<Link to={`/blog/${this.props.parentId.blog._id}-${this.props.article.blog.slug}`}>*/}
                                        {/*    &nbsp;{this.props.article.blog.title}*/}
                                        {/*</Link>)}*/}
                                        a ajouté un sujet au forum {this.props.parentId.forum.name}
                                    </div>
                                    <span className="text small medium-grey full">
                                                    <DateSince
                                                        date={this.props.createdAt}
                                                        prefix={true}
                                                        currentFormat={true}
                                                    />
                                                </span>
                                </div>
                            </div>
                            <div className="body">
                                <div>
                                    <div className="content">
                                        <div>
                                            <div
                                                className={"title forum-type"}>
                                                <Link to={link}>
                                                    <Icon type={"icon-comment"}/>
                                                    {this.props.parentId.title || ""}
                                                </Link>
                                            </div>
                                            <DraftContentExcerpt maxLine={10} contentRaw={content} />
                                            <div className={"forum-last-answer"}>
                                                <span>Dernière réponse :</span>
                                                {hasLastCommentOwner ? (
                                                    <Link to={createLink("userProfile", this.props.parentId.lastComment.owner)} {...relLinkProfilLastComment}>
                                                        <div className={"last-user"}>
                                                            <Avatar
                                                                avatar={this.props.parentId.lastComment.owner.profile.avatar}
                                                                gender={this.props.parentId.lastComment.owner.profile.gender}/>
                                                            {this.props.parentId.lastComment.owner.username}
                                                        </div>
                                                    </Link>
                                                ) : (
                                                    <div className={"last-user"}>
                                                        <Avatar gender={"guest"} />
                                                        Utilisateur Inconnu
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer">
                        <Views type="icon"
                               value={this.props.parentId.count && (this.props.parentId.count.view || 0)}/>
                        <Answers value={this.props.parentId.commentsCount}/>
                    </div>
                </Fragment>
            </div>
        )
    }
}

TopicStatus.defaultProps = {
    title: "",
    slug: '',
    article: {
        comment: {
            allowed: false
        },
        count: {
            view: 0,
            like: 0,
            comment: 0
        }
    },
    owner: {
        _id: 0,
        slug: '',
        username: '',
        avatar: "",
        gender: ""
    },
    authorName: ""
};


export default TopicStatus;
